import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './containers/app';
import registerServiceWorker from './registerServiceWorker';

window.FPS = 20;

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
registerServiceWorker();
